import { render, staticRenderFns } from "./OrderButton.vue?vue&type=template&id=6b655c63&scoped=true&"
import script from "./OrderButton.vue?vue&type=script&lang=js&"
export * from "./OrderButton.vue?vue&type=script&lang=js&"
import style0 from "./OrderButton.vue?vue&type=style&index=0&id=6b655c63&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b655c63",
  null
  
)

export default component.exports